import * as React from 'react';
import { connect } from 'react-redux';
import LoaderComponent from 'src/components/common/loader.component';
import { ApplicationMain } from 'src/styles/common';
import { getCurrentUrl } from 'src/effects/utils/common';
import { AdminDashboardWrapper } from '../styles/admindashboard';
import { userAdminDashboard, userRegionalAdminDashboard, saveReminderConfig, countryModulTypeDashboard, unmountDashboardData } from 'src/actions/action.userDashboard';
import { push } from 'connected-react-router';
import AdminResponseComponent from 'src/components/AdminDashboardResponse/AdminResponseComponent';
import { downloadExcel } from 'src/actions/action.report';
import { getProgresReportCall } from 'src/effects/api/api.report';
import * as PropTypes from 'prop-types';

class HQAdminResponseContainerContainer extends React.Component<any, any> {
    static contextTypes = {
        router: PropTypes.object
    }

    state = {
        currentPageTitle: '',
        isAdmin: false,
        dashobardData: {},
        surveys: [],
        selectedSurvey: '',
        selectedSurveyId: 0,
        isDashboard: true,
        showReminder: false,
        show: false,
        countryModuleDetails: [],
    };

    constructor(props: any) {
        super(props);
        this.gotoResponses = this.gotoResponses.bind(this);
        this.handleSurvyeYearChange = this.handleSurvyeYearChange.bind(this);
        this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
        this.downloadProgressReport = this.downloadProgressReport.bind(this);
        this.handleDownloadAllModule=this.handleDownloadAllModule.bind(this);
    }

    componentDidMount() {
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            const surveyId: any = parseInt(splitUrl[4], 10);

            if (splitUrl[3].indexOf('hq-admin-survey-response') > -1) {
                this.props.userAdminDashboard({ surveyId, isDashboard: false });
                this.setState({ isAdmin: true, selectedSurveyId: surveyId });
            }
            else {
                this.props.userRegionalAdminDashboard({ surveyId, isDashboard: true });
                this.setState({ isAdmin: false, selectedSurveyId: surveyId });
            }

        });
    }
    handleSurvyeYearChange(selectedSurveyId: any) {

        const surveys: any = this.state.surveys.filter((item: any) => (item.statusText !== "Draft" && item.id === selectedSurveyId))
        if (surveys && surveys.length > 0) {
            this.setState({
                selectedSurvey: surveys[0],
                selectedSurveyId: surveys[0].id
            }, () => {
                this.setState({
                    selectedSurveyId: surveys[0].id,
                    selectedSurvey: surveys[0]
                })
            })
        }
        const data = {
            surveyId: selectedSurveyId,
            isDashboard: true
        }
        this.state.isAdmin ? this.props.userAdminDashboard(data) : this.props.userRegionalAdminDashboard(data)
    }
    gotoResponses(isDashboard: any) {
        this.setState({
            isDashboard
        });
        this.props.redirectTo(this.state.isAdmin ? '/hq-admin-dashboard/' + this.state.selectedSurveyId : '/regional-admin-dashboard/' + this.state.selectedSurveyId)
    }

    downloadProgressReport() {
        this.setState({ show: true });
        const selectedSurvey: any = this.state.selectedSurvey;

        getProgresReportCall(selectedSurvey).then((response: any) => {
            this.setState({ show: false });
        });
    }

    UNSAFE_componentWillReceiveProps(props: any) {
        if (props && ((props.adminDashboard && (Object.keys(props.adminDashboard).length > 0)) || (props.regionalDashboard && Object.keys(props.regionalDashboard).length > 0))) {
            this.setState({
                dashobardData: this.state.isAdmin ? props.adminDashboard : props.regionalDashboard
            })
        }

        if (props && props.surveys && props.surveys.length > 0) {
            const surveys: any = props.surveys ? props.surveys.filter((item: any) => (item.statusText !== "Draft" && item.id === this.state.selectedSurveyId)) : [];

            this.setState({
                surveys,
                selectedSurvey: surveys[0]
            })
        }

        if (props && props.countryModuleDetails) {
            this.setState({
                countryModuleDetails: props.countryModuleDetails
            })
        }
    }

    handleDownloadExcel = (selectedRegionId: any, selectedCountryId: any, selectedModuleId: any) => {
        const regionIdList: string[] = [];
        const countryIdList: string[] = [];
        if (selectedRegionId === -1) {
            this.props.countryRegions.map((cr: any, index: any) => {
                regionIdList.push(cr.id);
                cr.countries.map((c: any, index2: any) => {
                    countryIdList.push(c.id);
                })
            });
        }
        else {
            regionIdList.push(selectedRegionId);
            if (selectedCountryId === -1) {
                const selectedRegion: any = this.props.countryRegions.find((cr: any) => (cr.id === selectedRegionId));
                if (selectedRegion && selectedRegion.countries && selectedRegion.countries.length > 0) {
                    selectedRegion.countries.map((c: any, index: any) => {
                        countryIdList.push(c.id);
                    })
                }
            }
            else {
                countryIdList.push(selectedCountryId);
            }
        }

        let selectedModuleName = "";
        if (selectedModuleId !== -1) {
            const selectedModule: any = this.props.models.find((m: any) => (m.id === selectedModuleId));
            if (selectedModule && selectedModule.name) {
                selectedModuleName = selectedModule.name;
            }
        }

        let selectedSurveyName = "";
        if (this.state.selectedSurveyId && this.state.selectedSurveyId !== 0) {
            const selectedSurvey: any = this.state.surveys.find((s: any) => (s.id === this.state.selectedSurveyId));
            if (selectedSurvey && selectedSurvey.title) {
                selectedSurveyName = selectedSurvey.title;
            }
        }

        const ReportRequestDto = {
            RegionIdList: [] as string[],
            CountryIdList: [] as string[],
            ModuleId: 0,
            ModuleName: "",
            SurveyId: 0,
            SurveyName: ""
        }
        ReportRequestDto.RegionIdList = regionIdList;
        ReportRequestDto.CountryIdList = countryIdList;
        ReportRequestDto.ModuleId = selectedModuleId;
        ReportRequestDto.ModuleName = selectedModuleName;
        ReportRequestDto.SurveyId = this.state.selectedSurveyId;
        ReportRequestDto.SurveyName = selectedSurveyName;

        this.props.downloadExcel(ReportRequestDto);
    }

    handleDownloadAllModule()
    {
        console.log("HQ admin response container");
        // this.props.handleDownloadAllModule();

    }
    componentWillUnmountMount() {
        this.props.unmountDashboardData();
    }
    render() {
        const dashboardData: any = this.state.dashobardData;

        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show || this.state.show} />

                <AdminDashboardWrapper>
                    <div className="pageContainer adminScreen">
                        {
                            dashboardData && Object.keys(dashboardData).length > 0 &&
                            <AdminResponseComponent
                                dashboardData={dashboardData}
                                selectedSurvey={this.state.selectedSurvey}
                                selectedSurveyId={this.state.selectedSurveyId}
                                gotoResponses={this.gotoResponses}
                                isAdmin={this.state.isAdmin}
                                surveys={this.state.surveys}
                                saveReminderConfig={this.props.saveReminderConfig}
                                countryModulTypeDashboard={this.props.countryModulTypeDashboard}
                                countryModuleDetails={this.state.countryModuleDetails}
                            />
                        }
                    </div>
                </AdminDashboardWrapper>
            </ApplicationMain>
        );
    }
}

const mapStateToProps = (state: any) => {
    // console.log("mapStateToProps - countryRegions - ", state.common.countryRegions);
    return {
        show: state.common.show,
        surveys: state.survey.surveys,
        adminDashboard: state.userDashboard.userAdminDashboard,
        regionalDashboard: state.userDashboard.userReionalAdminDashboard,
        countryModuleDetails: state.userDashboard.countryModuleDetails,
        countryRegions: state.common.countryRegions,
        models: state.model.models,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (path: string) => dispatch(push(path)),
        saveReminderConfig: (data: any) => dispatch(saveReminderConfig(data)),
        userAdminDashboard: (surveyId: any) => dispatch(userAdminDashboard(surveyId)),
        userRegionalAdminDashboard: (surveyId: any) => dispatch(userRegionalAdminDashboard(surveyId)),
        countryModulTypeDashboard: (data: any) => dispatch(countryModulTypeDashboard(data)),
        unmountDashboardData: () => dispatch(unmountDashboardData()),
        downloadExcel: (data: any) => dispatch(downloadExcel(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HQAdminResponseContainerContainer);



// WEBPACK FOOTER //
// ./src/containers/HQAdminResponseContainer.tsx